import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=64d2f1cf&"
import script from "./input-number.vue?vue&type=script&lang=js&"
export * from "./input-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d2f1cf')) {
      api.createRecord('64d2f1cf', component.options)
    } else {
      api.reload('64d2f1cf', component.options)
    }
    module.hot.accept("./input-number.vue?vue&type=template&id=64d2f1cf&", function () {
      api.rerender('64d2f1cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-number/input-number.vue"
export default component.exports